/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  QUESTION_LIST,
  QUESTION_CREATE,
  QUESTION_UPDATE,
  QUESTION_DETAILS,
  SUBJECT_LIST,
  TOPIC_LIST,
  QUESTION_BULK_UPLOAD,
  QUESTIONNAIRE_UPLOAD,
  UPLOAD_QUESTIONNAIRE_HISTORY,
  QUESTIONNAIRE_LIST,
  QUESTIONNAIRE_DETAILS,
  QUESTIONNAIRE_DELETE,
  DELETE_UPLOAD_HISTORY,
  GET_QUESTION_PAPER,
  GET_EXAM_QUESTION,
  SUBJECT_WISE_TOPIC_LIST,
} from '../constants/action-types'
import { BulkUploadQuestionList, QuestionData } from '../Actions'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'

const initialState = {
  isLoading: false,
  isQuestionnaireListLoading: true,
  isTopicListLoading: false,
  errorMessage: '',
  QuestionList: [],
  SubjectList: [],
  TopicList: { data: [] },
  QuestionDetails: Object,
  createQuestionData: Object,
  bulkQuestions: null,
  questionnaireHistory: { count: 0, history: [] },
  questionnaireList: [],
  questionnaireCount: 0,
  questionnaireDetails: null,
  questionPaperDetailsForExam: null,
  examQuestions: [],
}

const reducer = persistReducer(
  {
    storage,
    key: 'basecode-demo',
    whitelist: ['user', 'questionnaireDetails'],
  },
  (state: QuestionData = initialState, action: ActionTypes) => {
    switch (action.type) {
      case QUESTION_LIST.QUESTION_LIST_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case QUESTION_LIST.QUESTION_LIST_SUCCESS:
        const questions: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          QuestionList: questions,
        }

      case QUESTION_LIST.QUESTION_LIST_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }

      //create batch
      case QUESTION_CREATE.QUESTION_CREATE_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case QUESTION_CREATE.QUESTION_CREATE_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
        }

      case QUESTION_CREATE.QUESTION_CREATE_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }

      //UPDATE batch
      case QUESTION_UPDATE.QUESTION_UPDATE_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case QUESTION_UPDATE.QUESTION_UPDATE_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
        }

      case QUESTION_UPDATE.QUESTION_UPDATE_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }
      //Details Question
      case QUESTION_DETAILS.QUESTION_DETAILS_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case QUESTION_DETAILS.QUESTION_DETAILS_SUCCESS:
        const questionDetails: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          QuestionDetails: questionDetails,
        }

      case QUESTION_DETAILS.QUESTION_DETAILS_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }
      // Subject List
      case SUBJECT_LIST.SUBJECT_LIST_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case SUBJECT_LIST.SUBJECT_LIST_SUCCESS:
        const subjects: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          SubjectList: subjects,
        }

      case SUBJECT_LIST.SUBJECT_LIST_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }
      // Topic List
      case TOPIC_LIST.TOPIC_LIST_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case TOPIC_LIST.TOPIC_LIST_SUCCESS:
        const topics: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          TopicList: topics,
        }

      case TOPIC_LIST.TOPIC_LIST_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }

      case QUESTION_BULK_UPLOAD.GET_BULK_UPLOAD_QUESTIONS_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }

      case QUESTION_BULK_UPLOAD.GET_BULK_UPLOAD_QUESTIONS_ERORR:
        return {
          ...state,
          errorMessage: action.payload,
          isLoading: false,
        }
      case QUESTION_BULK_UPLOAD.GET_BULK_UPLOAD_QUESTIONS_SUCCESS:
        const bulkQuestionsPayload =
          action.payload as unknown as BulkUploadQuestionList
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          bulkQuestions: bulkQuestionsPayload,
        }

      //Upload Questionnaire
      case QUESTIONNAIRE_UPLOAD?.QUESTIONNAIRE_UPLOAD_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case QUESTIONNAIRE_UPLOAD?.QUESTIONNAIRE_UPLOAD_SUCCESS:
        return {
          ...state,
          isLoading: false,
        }
      case QUESTIONNAIRE_UPLOAD?.QUESTIONNAIRE_UPLOAD_ERROR:
        return {
          ...state,
          isLoading: false,
        }

      //Questionnaire History
      case UPLOAD_QUESTIONNAIRE_HISTORY.UPLOAD_QUESTIONNAIRE_HISTORY_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case UPLOAD_QUESTIONNAIRE_HISTORY.UPLOAD_QUESTIONNAIRE_HISTORY_SUCCESS:
        const questionnaireHistory: any = action.payload
        return {
          ...state,
          isLoading: false,
          questionnaireHistory: {
            history: questionnaireHistory?.results,
            count: questionnaireHistory?.count,
          },
        }
      case UPLOAD_QUESTIONNAIRE_HISTORY.UPLOAD_QUESTIONNAIRE_HISTORY_ERROR:
        return {
          ...state,
          isLoading: false,
        }

      //Questionnaire List
      case QUESTIONNAIRE_LIST.QUESTIONNAIRE_LIST_INITIALIZATION:
        return {
          ...state,
          isQuestionnaireListLoading: true,
          questionnaireList: [],
        }
      case QUESTIONNAIRE_LIST.QUESTIONNAIRE_LIST_SUCCESS:
        const questionnaireList: any = action?.payload
        return {
          ...state,
          isQuestionnaireListLoading: false,
          questionnaireList: questionnaireList?.results,
          questionnaireCount: questionnaireList?.count,
        }
      case QUESTIONNAIRE_LIST.QUESTIONNAIRE_LIST_ERROR:
        return {
          ...state,
          isQuestionnaireListLoading: false,
        }

      case QUESTIONNAIRE_DETAILS.QUESTIONNAIRE_DETAILS_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
          questionnaireDetails: null,
        }
      case QUESTIONNAIRE_DETAILS.QUESTIONNAIRE_DETAILS_SUCCESS:
        const questionnaireDetails: any = action.payload
        return {
          ...state,
          isLoading: false,
          questionnaireDetails: questionnaireDetails,
        }
      case QUESTIONNAIRE_DETAILS.QUESTIONNAIRE_DETAILS_ERROR:
        return {
          ...state,
          isLoading: false,
        }
      case QUESTIONNAIRE_DELETE.QUESTIONNAIRE_DELETE_INITIALIZATION:
        return {
          ...state,
          isQuestionnaireListLoading: true,
        }
      case QUESTIONNAIRE_DELETE.QUESTIONNAIRE_DELETE_SUCCESS:
        return {
          ...state,
          isQuestionnaireListLoading: false,
        }
      case QUESTIONNAIRE_DELETE.QUESTIONNAIRE_DELETE_ERROR:
        return {
          ...state,
          isQuestionnaireListLoading: false,
        }
      case DELETE_UPLOAD_HISTORY.DELETE_UPLOAD_HISTORY_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case DELETE_UPLOAD_HISTORY.DELETE_UPLOAD_HISTORY_SUCCESS:
        return {
          ...state,
          isLoading: false,
        }
      case DELETE_UPLOAD_HISTORY.DELETE_UPLOAD_HISTORY_ERROR:
        return {
          ...state,
          isLoading: false,
        }

      case GET_QUESTION_PAPER.GET_QUESTION_PAPER_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }

      case GET_QUESTION_PAPER.GET_QUESTION_PAPER_SUCCESS:
        const payload = action.payload as any
        return {
          ...state,
          isLoading: false,
          questionPaperDetailsForExam: payload,
        }

      case GET_QUESTION_PAPER.GET_QUESTION_PAPER_FAILED:
        return {
          ...state,
          isLoading: false,
        }
      case GET_EXAM_QUESTION.GET_EXAM_QUESTION_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }

      case GET_EXAM_QUESTION.GET_EXAM_QUESTION_SUCCESS:
        const examQuestions = action.payload as any
        return {
          ...state,
          isLoading: false,
          examQuestions: examQuestions,
        }

      case GET_EXAM_QUESTION.GET_EXAM_QUESTION_FAILED:
        return {
          ...state,
          isLoading: false,
        }

      case SUBJECT_WISE_TOPIC_LIST.SUBJECT_WISE_TOPIC_LIST_INITIALIZATION:
        return {
          ...state,
          isTopicListLoading: true,
        }
      case SUBJECT_WISE_TOPIC_LIST.SUBJECT_WISE_TOPIC_LIST_ERORR:
        return {
          ...state,
          isTopicListLoading: false,
        }
      case SUBJECT_WISE_TOPIC_LIST.SUBJECT_WISE_TOPIC_LIST_SUCCESS:
        const TopicList: any = action?.payload
        return {
          ...state,
          isTopicListLoading: false,
          TopicList,
        }
      default:
        return state
    }
  }
)

export default reducer
